import { ChatBotResponseType, GraphType } from '../../ChatBotData';
import BarGraph from '../../../../assets/Images/barGraph.svg';
import pieChart from '../../../../assets/Images/pieChart.svg';
import tableIcon from '../../../../assets/Images/table.svg';
import donutChart from '../../../../assets/Images/donutChart.svg';
import horizontalBarGraph from '../../../../assets/Images/horizontalGraph.svg';
import layerGraph from '../../../../assets/Images/SplineGraph.svg';
import headerService from '../../../../services/header.service';
import DataTableWithServerPagination from '../../../../components/DataTable/DataTableWithServerPagination';
import BarGraphChatBot from '../../Graphs/BarGraphChatBot';
import DonutChart from '../../Graphs/DonutChart';

export function getGraphIcons(iconType) {
	switch (iconType) {
		case GraphType?.BAR_CHART:
			return (
				<img
					className='whiteColor'
					src={BarGraph}
					width={'27px'}
					height={'27px'}
					alt=''
				/>
			);
		case GraphType?.HORIZONTAL:
			return (
				<img
					className='whiteColor'
					src={horizontalBarGraph}
					width={'27px'}
					height={'27px'}
					alt=''
				/>
			);
		case GraphType?.DONUT_GRAPH:
			return (
				<img
					className='whiteColor'
					src={donutChart}
					width={'27px'}
					height={'27px'}
					alt=''
				/>
			);
		case GraphType?.PIE_CHART:
			return (
				<img
					className='whiteColor'
					src={pieChart}
					width={'27px'}
					height={'27px'}
					alt=''
				/>
			);
		case GraphType?.LINE_GRAPH:
			return (
				<img
					className='whiteColor'
					src={layerGraph}
					width={'27px'}
					height={'27px'}
					alt=''
				/>
			);
		case GraphType?.DATA_TABLE:
			return (
				<img
					className='whiteColor'
					src={tableIcon}
					width={'27px'}
					height={'27px'}
					alt=''
				/>
			);
		default:
			return <></>;
	}
}

function handleDataTableData(responseData) {
	let headingForDataTable = [];

	if (!responseData?.length) return headingForDataTable;

	const firstRow = responseData[0];

	for (let key in firstRow) {
		headingForDataTable.push({
			name: key,
			selector: row => row[key],
			center: true,
			cell: row => {
				const value = row[key] ?? '';
				const text = String(value);
				const isLong = text.length > 10;
				return (
					<div
						title={isLong ? text : ''}
						style={{
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							maxWidth: '250px'
						}}
					>
						{text}
					</div>
				);
			}
		});
	}

	return headingForDataTable;
}



function getBarGraphChartData(graphData, graphType, graphsToShow) {
	return {
		categories: graphData[graphData?.x_key],
		series: {
			name: 'Months',
			data: graphData[graphData?.y_key],
			cursor: 'pointer',
		},
		xAxisName: graphData?.x_key,
		yAxisName: graphData?.y_key,
		graphType: graphType,
		availableGraphs: graphsToShow,
	};
}

function handleDonutGraphData(graphData, graphType, graphsToShow) {
	let seriesData = [];
	for (let index = 0; index < graphData[graphData?.x_key].length; index++) {
		seriesData.push({
			y: graphData[graphData?.y_key][index],
			name: graphData[graphData?.x_key][index],
		});
	}
	return {
		series: seriesData,
		xAxisName: graphData?.x_key,
		yAxisName: graphData?.y_key,
		graphType: graphType,
		availableGraphs: graphsToShow,
	};
}

export function handleGraphAccordingToType(
	recommendedGraph,
	graphData,
	graphsToShow,
	responseAnswer,
	questionData
) {
	switch (recommendedGraph) {
		case GraphType?.BAR_CHART:
			return getBarGraphChartData(graphData, GraphType.BAR_CHART, graphsToShow);
		case GraphType?.PIE_CHART:
			return handleDonutGraphData(graphData, GraphType.PIE_CHART, graphsToShow);
		case GraphType?.HORIZONTAL:
			return getBarGraphChartData(
				graphData,
				GraphType?.HORIZONTAL,
				graphsToShow
			);
		case GraphType?.DONUT_GRAPH:
			return handleDonutGraphData(
				graphData,
				GraphType?.DONUT_GRAPH,
				graphsToShow
			);
		case GraphType?.DATA_TABLE: {
			let dataTableColumns = handleDataTableData(responseAnswer);
			return returnDataTableUi(dataTableColumns, responseAnswer, questionData);
		}
		case GraphType?.LINE_GRAPH:
			return getBarGraphChartData(
				graphData,
				GraphType?.LINE_GRAPH,
				graphsToShow
			);
		default:
			break;
	}
}

function returnDataTableUi(dataTableColumns, dataTableData, questionData) {
	return (
		<div >
			<DataTableWithServerPagination
				data={dataTableData}
				columns={dataTableColumns}
				handlePageChange={(event) => {
					const data = {
						type: 'paginationChange',
						data: { ...questionData, offSet: event },
					};
					headerService.emit(data);
				}}
				handlePerRowsChange={(event, page) => {
					const data = {
						type: 'paginationChange',
						data: { ...questionData, limit: event, offSet: page },
					};
					headerService?.emit(data);
				}}
				itemsPerPage={questionData?.limit}
				totalRows={questionData?.totalRows}
				showPagination
				limit={questionData?.limit}
				page={questionData?.offSet}
				serverPagination={true}
				style={{ margin: '0px!important' }}
			/>
		</div>
	);
}

const graphAvaiableRightNow = [0, 3, 4, 5, 6, 7];

export function handleResponseAccordingToType(response) {
	let responseType = response?.response_type;
	let responseAnswer = response?.answer;
	let questionData = {
		questionId: response?.keys?.qid,
		uniqueId : response?.keys?.uniqueId||response?.uniqueId,
		totalRows: response?.size,
		question: response?.keys?.question || response?.question,
		selectedCategory: response?.keys?.dataSource,
		offSet: response?.keys?.offSet || response?.offSet,
		limit: response?.keys?.limit || response?.limit,
	};
	let recommendedGraphType  = 0;
	if(graphAvaiableRightNow?.includes(response?.graph_type?.default)){
		recommendedGraphType = response?.graph_type?.default;
	}
	let recommendedGraph = recommendedGraphType || 0;
	switch (responseType) {
		case ChatBotResponseType?.DATA_TABLE_AND_BAR_GRAPH_RESPONSE:
			if (
				response?.graph_type 
			) {
				let graphsToShow = response?.graph_type.all;
				let graphData = response?.graph_data;
				return handleGraphAccordingToType(
					recommendedGraph,
					graphData,
					graphsToShow,
					responseAnswer,
					questionData
				);
			} else {
				let dataTableColumns = handleDataTableData(responseAnswer);
				return returnDataTableUi(
					dataTableColumns,
					responseAnswer,
					questionData
				);
			}

		case ChatBotResponseType?.INTEGER_TYPE_RESPONSE:
			return responseAnswer?.toFixed(2) || 'Something Went Wrong';
		case ChatBotResponseType?.STRING_RESPONSE:
			return responseAnswer || 'Something Went Wrong';
		default:
			return responseAnswer;
	}
}


export const renderUiAccordingToGraphType = (graphType, graphData) => {
	if (!graphAvaiableRightNow.includes(graphType)) {
		graphType = 0;
	}
	switch (graphType) {
		case GraphType.BAR_CHART:
			return (
				<div style={{ maxWidth: '95%', marginTop: '10px' }}>
					<BarGraphChatBot
						type='column'
						xAxisName={graphData?.xAxisName}
						yAxisName={graphData?.yAxisName}
						categories={graphData?.categories || []}
						series={graphData?.series || []}
					/>
				</div>
			);
		case GraphType.HORIZONTAL:
			return (
				<div style={{ maxWidth: '95%', marginTop: '10px' }}>
					<BarGraphChatBot
						type='bar'
						yAxisName={graphData?.yAxisName}
						xAxisName={graphData?.xAxisName}
						categories={graphData?.categories || []}
						series={graphData?.series || []}
					/>
				</div>
			);

		case GraphType.DONUT_GRAPH:
			return (
				<div style={{ maxWidth: '95%', marginTop: '10px' }}>
					<DonutChart
						colors={[
							'rgb(33, 49, 66)',
							'rgb(108, 99, 255)',
							'rgb(0, 233, 250)',
							'rgb(2, 188, 119)',
							'rgb(224, 124, 36)',
							'rgb(255, 156, 127)',
							'#213142',
						]}
						isFromCustomReport={true}
						isFiveSplice={false}
						xAndYAxisName={graphData?.xAxisName}
						customReportStyle={{
							// backgroundColor: theme.palette.background.light,
							width: '100%',
							margin: 'auto',
							justifyContent: 'center',
							display: 'flex',
							borderRadius: '20px',
						}}
						showLegend={true}
						innerRadius={200}
						height='480'
						enableDataLabels={true}
						width='1000'
						data={graphData?.series || []}
					/>
				</div>
			);
		case GraphType.LINE_GRAPH:
			return (
				<div style={{ maxWidth: '95%', marginTop: '10px' }}>
					<BarGraphChatBot
						type='spline'
						yAxisName={graphData?.yAxisName}
						xAxisName={graphData?.xAxisName}
						categories={graphData?.categories || []}
						series={graphData?.series || []}
					/>
				</div>
			);
		case GraphType.PIE_CHART:
			return (
				<div style={{ maxWidth: '95%', marginTop: '10px' }}>
					<BarGraphChatBot
						type='pie'
						xAxisName={graphData?.xAxisName}
						yAxisName={graphData?.yAxisName}
						categories={[]}
						series={{ data: graphData?.series || [] }}
					/>
				</div>
			);
		default:
			return (
				<span
					// style={{ color: theme.palette.text.primary }}
					className='answerSection'
				>
					{graphData}
						</span>
			);
	}
};


export const transformApiToChatFormat = (apiData) => {
  if (!Array.isArray(apiData)) return [];
  return apiData.map((item) => {
    const isArrayAnswer = Array.isArray(item.answer);
    return {
      question: item.question,
      originalResponse: {
		api_metadata:item.metadata.api_metadata,
        keys: {
          offSet: 1,
          question: item.question,
          limit: 10,
          uniqueId: item.metadata?.qid || Date.now().toString(),
        },
		created_at:item.created_at,
        answer: item.answer,
        response_type: item.metadata?.response_type ?? null,
        graph_data: {},
        graph_type: null,
        qid: item.metadata?.qid ?? "",
        size: isArrayAnswer ? item.answer.length : 1,
        question: item.question,
        fromPagination: false,
        showLink: false,
		chatId:item.thread_id
      },
      isEdit: false,
      dataSource: 5,
      isLike: false,
      isDisLike: false,
      isBookMark: false,
      isLoadingComplete: true,
      selectedGraph: null,
      availableGraphs: null,
      uniqueId: item.metadata?.qid || Date.now().toString(),
      offSet: 1,
      limit: 10,
      fromPagination: false,
	  isloadingPreviousChat:true,
	  hideLike:true,
    };
  });
};

